export default __webpack_public_path__ + "static/media/demoImage.1c01fc46.svg";